import { addHours, addMonths, differenceInMilliseconds, set } from 'date-fns';
import { formatInTimeZone, getTimezoneOffset } from 'date-fns-tz';

export const timezonesMap = {
  UTC: 'UTC',
  'International Date Line West': 'Pacific/Funafuti',
  'American Samoa': 'Pacific/Samoa',
  'Midway Island': 'Pacific/Midway',
  Hawaii: 'Pacific/Honolulu',
  Alaska: 'America/Anchorage',
  'Pacific Time (US & Canada)': 'Canada/Pacific',
  Tijuana: 'America/Tijuana',
  Arizona: 'America/Phoenix',
  Chihuahua: 'America/Chihuahua',
  Mazatlan: 'America/Mazatlan',
  'Mountain Time (US & Canada)': 'America/Denver',
  'Central America': 'America/Mexico_City',
  'Central Time (US & Canada)': 'America/Chicago',
  Guadalajara: 'America/Mexico_City',
  'Mexico City': 'America/Mexico_City',
  Monterrey: 'America/Monterrey',
  Saskatchewan: 'Canada/Saskatchewan',
  Bogota: 'America/Bogota',
  'Eastern Time (US & Canada)': 'America/New_York',
  'Indiana (East)': 'US/East-Indiana',
  Lima: 'America/Lima',
  Quito: 'America/Guayaquil',
  'Atlantic Time (Canada)': 'America/Halifax',
  Caracas: 'America/Caracas',
  Georgetown: 'America/Guyana',
  'La Paz': 'America/La_Paz',
  'Puerto Rico': 'America/Puerto_Rico',
  Santiago: 'America/Santiago',
  Newfoundland: 'Canada/Newfoundland',
  Brasilia: 'America/Sao_Paulo',
  'Buenos Aires': 'America/Argentina/Buenos_Aires',
  Greenland: 'America/Godthab',
  Montevideo: 'America/Montevideo',
  'Mid-Atlantic': 'America/Noronha',
  Azores: 'Atlantic/Azores',
  'Cape Verde Is.': 'Atlantic/Cape_Verde',
  Casablanca: 'Africa/Casablanca',
  Dublin: 'Europe/Dublin',
  Edinburgh: 'Europe/London',
  Lisbon: 'Europe/Lisbon',
  London: 'Europe/London',
  Monrovia: 'Africa/Monrovia',
  Amsterdam: 'Europe/Amsterdam',
  Belgrade: 'Europe/Belgrade',
  Berlin: 'Europe/Berlin',
  Bern: 'Europe/Zurich',
  Bratislava: 'Europe/Bratislava',
  Brussels: 'Europe/Brussels',
  Budapest: 'Europe/Budapest',
  Copenhagen: 'Europe/Copenhagen',
  Ljubljana: 'Europe/Ljubljana',
  Madrid: 'Europe/Madrid',
  Paris: 'Europe/Paris',
  Prague: 'Europe/Prague',
  Rome: 'Europe/Rome',
  Sarajevo: 'Europe/Sarajevo',
  Skopje: 'Europe/Skopje',
  Stockholm: 'Europe/Stockholm',
  Vienna: 'Europe/Vienna',
  Warsaw: 'Europe/Warsaw',
  'West Central Africa': 'Africa/Bangui',
  Zagreb: 'Europe/Zagreb',
  Zurich: 'Europe/Zurich',
  Athens: 'Europe/Athens',
  Bucharest: 'Europe/Bucharest',
  Cairo: 'Africa/Cairo',
  Harare: 'Africa/Harare',
  Helsinki: 'Europe/Helsinki',
  Jerusalem: 'Asia/Jerusalem',
  Kaliningrad: 'Europe/Kaliningrad',
  Kyiv: 'Europe/Kiev',
  Pretoria: 'Africa/Johannesburg',
  Riga: 'Europe/Riga',
  Sofia: 'Europe/Sofia',
  Tallinn: 'Europe/Tallinn',
  Vilnius: 'Europe/Vilnius',
  Baghdad: 'Asia/Baghdad',
  Istanbul: 'Asia/Istanbul',
  Kuwait: 'Asia/Kuwait',
  Minsk: 'Europe/Minsk',
  Moscow: 'Europe/Moscow',
  Nairobi: 'Africa/Nairobi',
  Riyadh: 'Asia/Riyadh',
  'St. Petersburg': 'Europe/Moscow',
  Tehran: 'Asia/Tehran',
  'Abu Dhabi': 'Asia/Dubai',
  Baku: 'Asia/Baku',
  Muscat: 'Asia/Muscat',
  Samara: 'Europe/Samara',
  Tbilisi: 'Asia/Tbilisi',
  Volgograd: 'Europe/Volgograd',
  Yerevan: 'Asia/Yerevan',
  Kabul: 'Asia/Kabul',
  Ekaterinburg: 'Asia/Yekaterinburg',
  Islamabad: 'Asia/Karachi',
  Karachi: 'Asia/Karachi',
  Tashkent: 'Asia/Tashkent',
  Chennai: 'Asia/Kolkata',
  Kolkata: 'Asia/Kolkata',
  Mumbai: 'Asia/Kolkata',
  'New Delhi': 'Asia/Kolkata',
  'Sri Jayawardenepura': 'Asia/Colombo',
  Kathmandu: 'Asia/Kathmandu',
  Almaty: 'Asia/Almaty',
  Astana: 'Asia/Almaty',
  Dhaka: 'Asia/Dhaka',
  Urumqi: 'Asia/Urumqi',
  Rangoon: 'Asia/Rangoon',
  Bangkok: 'Asia/Bangkok',
  Hanoi: 'Asia/Bangkok',
  Jakarta: 'Asia/Jakarta',
  Krasnoyarsk: 'Asia/Krasnoyarsk',
  Novosibirsk: 'Asia/Novosibirsk',
  Beijing: 'Asia/Shanghai',
  Chongqing: 'Asia/Chongqing',
  'Hong Kong': 'Asia/Hong_Kong',
  Irkutsk: 'Asia/Irkutsk',
  'Kuala Lumpur': 'Asia/Kuala_Lumpur',
  Perth: 'Australia/Perth',
  Singapore: 'Asia/Singapore',
  Taipei: 'Asia/Taipei',
  Ulaanbaatar: 'Asia/Ulaanbaatar',
  Osaka: 'Asia/Tokyo',
  Sapporo: 'Asia/Tokyo',
  Seoul: 'Asia/Seoul',
  Tokyo: 'Asia/Tokyo',
  Yakutsk: 'Asia/Yakutsk',
  Adelaide: 'Australia/Adelaide',
  Darwin: 'Australia/Darwin',
  Brisbane: 'Australia/Brisbane',
  Canberra: 'Australia/Canberra',
  Guam: 'Pacific/Guam',
  Hobart: 'Australia/Hobart',
  Melbourne: 'Australia/Melbourne',
  'Port Moresby': 'Pacific/Port_Moresby',
  Sydney: 'Australia/Sydney',
  Vladivostok: 'Asia/Vladivostok',
  Magadan: 'Asia/Magadan',
  'New Caledonia': 'Pacific/Noumea',
  'Solomon Is.': 'Pacific/Guadalcanal',
  Srednekolymsk: 'Asia/Srednekolymsk',
  Auckland: 'Pacific/Auckland',
  Fiji: 'Pacific/Fiji',
  Kamchatka: 'Asia/Kamchatka',
  'Marshall Is.': 'Pacific/Majuro',
  Wellington: 'Pacific/Auckland',
  'Chatham Is.': 'Pacific/Chatham',
  "Nuku'alofa": 'Pacific/Tongatapu',
  Samoa: 'Pacific/Apia',
  'Tokelau Is.': 'Pacific/Fakaofo',
};

export const getDefaultStartDate = () => {
  const currentDate = new Date();
  const startDate = set(addMonths(currentDate, 1), {
    hours: 9,
    minutes: 0,
    seconds: 0,
    milliseconds: 0,
  });

  return startDate;
};

export const getDefaultEndDate = () => {
  const endDate = addHours(getDefaultStartDate(), 1);

  return endDate;
};

export const getDurationInMilliseconds = (eventStart: Date, eventEnd: Date) => {
  return eventStart && eventEnd
    ? differenceInMilliseconds(eventEnd, eventStart)
    : 0;
};

export const getInitialTimeValues = (timeStart: Date, timeEnd: Date) => {
  const startDate = timeStart ?? getDefaultStartDate();
  const endDate = timeEnd ?? getDefaultEndDate();
  const duration = getDurationInMilliseconds(startDate, endDate);

  return {
    startDate,
    endDate,
    duration,
  };
};

const utcTimezone = { label: '(GMT+00:00) UTC', value: 'UTC' };

const tzList = [
  'International Date Line West',
  'American Samoa',
  'Midway Island',
  'Hawaii',
  'Alaska',
  'Pacific Time (US & Canada)',
  'Tijuana',
  'Arizona',
  'Chihuahua',
  'Mazatlan',
  'Mountain Time (US & Canada)',
  'Central America',
  'Central Time (US & Canada)',
  'Guadalajara',
  'Mexico City',
  'Monterrey',
  'Saskatchewan',
  'Bogota',
  'Eastern Time (US & Canada)',
  'Indiana (East)',
  'Lima',
  'Quito',
  'Atlantic Time (Canada)',
  'Caracas',
  'Georgetown',
  'La Paz',
  'Puerto Rico',
  'Santiago',
  'Newfoundland',
  'Brasilia',
  'Buenos Aires',
  'Greenland',
  'Montevideo',
  'Mid-Atlantic',
  'Azores',
  'Cape Verde Is.',
  'Casablanca',
  'Dublin',
  'Edinburgh',
  'Lisbon',
  'London',
  'Monrovia',
  'UTC',
  'Amsterdam',
  'Belgrade',
  'Berlin',
  'Bern',
  'Bratislava',
  'Brussels',
  'Budapest',
  'Copenhagen',
  'Ljubljana',
  'Madrid',
  'Paris',
  'Prague',
  'Rome',
  'Sarajevo',
  'Skopje',
  'Stockholm',
  'Vienna',
  'Warsaw',
  'West Central Africa',
  'Zagreb',
  'Zurich',
  'Athens',
  'Bucharest',
  'Cairo',
  'Harare',
  'Helsinki',
  'Jerusalem',
  'Kaliningrad',
  'Kyiv',
  'Pretoria',
  'Riga',
  'Sofia',
  'Tallinn',
  'Vilnius',
  'Baghdad',
  'Istanbul',
  'Kuwait',
  'Minsk',
  'Moscow',
  'Nairobi',
  'Riyadh',
  'St. Petersburg',
  'Tehran',
  'Abu Dhabi',
  'Baku',
  'Muscat',
  'Samara',
  'Tbilisi',
  'Volgograd',
  'Yerevan',
  'Kabul',
  'Ekaterinburg',
  'Islamabad',
  'Karachi',
  'Tashkent',
  'Chennai',
  'Kolkata',
  'Mumbai',
  'New Delhi',
  'Sri Jayawardenepura',
  'Kathmandu',
  'Almaty',
  'Astana',
  'Dhaka',
  'Urumqi',
  'Rangoon',
  'Bangkok',
  'Hanoi',
  'Jakarta',
  'Krasnoyarsk',
  'Novosibirsk',
  'Beijing',
  'Chongqing',
  'Hong Kong',
  'Irkutsk',
  'Kuala Lumpur',
  'Perth',
  'Singapore',
  'Taipei',
  'Ulaanbaatar',
  'Osaka',
  'Sapporo',
  'Seoul',
  'Tokyo',
  'Yakutsk',
  'Adelaide',
  'Darwin',
  'Brisbane',
  'Canberra',
  'Guam',
  'Hobart',
  'Melbourne',
  'Port Moresby',
  'Sydney',
  'Vladivostok',
  'Magadan',
  'New Caledonia',
  'Solomon Is.',
  'Srednekolymsk',
  'Auckland',
  'Fiji',
  'Kamchatka',
  'Marshall Is.',
  'Wellington',
  'Chatham Is.',
  "Nuku'alofa",
  'Samoa',
  'Tokelau Is.',
];

// values returned from browser Intl timezone (that reads OS configuration) for generic timezones (no specific city set)
export const genericTimezonesMap = {
  Los_Angeles: 'Pacific Time (US & Canada)',
  Denver: 'Mountain Time (US & Canada)',
  Chicago: 'Central Time (US & Canada)',
  New_York: 'Eastern Time (US & Canada)',
  Halifax: 'Atlantic Time (Canada)',
  Lagos: 'West Central Africa',
  Katmandu: 'Kathmandu',
  St_Johns: 'Newfoundland',
  La_Paz: 'La Paz',
  Calcutta: 'Kolkata',
  'GMT-12': 'International Date Line West',
  'GMT-11': 'American Samoa',
  'GMT-10': 'Hawaii',
  'GMT-9': 'Alaska',
  'GMT-8': 'Pacific Time (US & Canada)',
  'GMT-7': 'Mountain Time (US & Canada)',
  'GMT-6': 'Central America',
  'GMT-5': 'Eastern Time (US & Canada)',
  'GMT-4': 'Atlantic Time (Canada)',
  'GMT-3': 'Greenland',
  'GMT-2': 'Mid-Atlantic',
  'GMT-1': 'Casablanca',
  GMT: 'UTC',
  'GMT+1': 'West Central Africa',
  'GMT+2': 'Jerusalem',
  'GMT+3': 'Istanbul',
  'GMT+4': 'Abu Dhabi',
  'GMT+5': 'Ekaterinburg',
  'GMT+6': 'Dhaka',
  'GMT+7': 'Jakarta',
  'GMT+8': 'Beijing',
  'GMT+9': 'Tokyo',
  'GMT+10': 'Brisbane',
  'GMT+11': 'Canberra',
  'GMT+12': 'Kamchatka',
  'GMT+13': 'Fiji',
  'GMT+14': 'Samoa',
};

export const timezones = (referenceDate = new Date()) => {
  const options = tzList
    .map(value => {
      const timezone = timezonesMap[value as keyof typeof timezonesMap];
      const offset = getTimezoneOffset(timezone, referenceDate);
      const formattedOffset = formatInTimeZone(referenceDate, timezone, 'XXX');
      const label = `(GMT${formattedOffset}) ${value}`
        .trim()
        .replace('GMTZ', 'GMT+00:00');

      return { label, value, offset };
    })
    .sort((a, b) => a.offset - b.offset);

  const optionsMap = new Map(
    options.map(option => [option.value, option.label]),
  );

  return { options, optionsMap };
};

/**
 * Returns the timezone of the browser in IANA format
 * @returns The timezone (e.g. "Europe/London")
 */
export function getBrowserTimezone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

const getTimezone = () => {
  try {
    const [region, browserTimezone] = getBrowserTimezone().split('/');
    return browserTimezone || region;
  } catch {
    return undefined;
  }
};

const getTzFromValue = (value: string) =>
  timezones().options.find(timezone => timezone.value === value);

export const getSelectedTimezone = () => {
  const browserTimezone = getTimezone();

  if (!browserTimezone) {
    return utcTimezone;
  }

  const selectedTimezone =
    getTzFromValue(browserTimezone) ||
    getTzFromValue(
      genericTimezonesMap[browserTimezone as keyof typeof genericTimezonesMap],
    );

  if (!selectedTimezone) {
    return utcTimezone;
  }

  return selectedTimezone;
};
